module.exports = __webpack_public_path__ + "img/commercial.6c51e33c.svg";